import Subregion from './Subregion';

export default Subregion;
